module.exports = __webpack_public_path__ + "media/flags/hr-49818b51.png";